import { apiPublic } from './apiPublic.service';
import apiPrivate from './apiPrivate.service';

const API_URL = '/chat';

class ChatService {
  async getRooms() {
    const response = await apiPublic.get(`${API_URL}/rooms`);
    return response.data;
  }

  async getMessages(roomId) {
    const response = await apiPublic.get(`${API_URL}/rooms/${roomId}/messages`);
    return response.data;
  }

  async joinRoom(roomId) {
    const response = await apiPrivate.post(`${API_URL}/rooms/${roomId}/join`);
    return response.data;
  }

  async postMessage(roomId, content) {
    const response = await apiPrivate.post(`${API_URL}/rooms/${roomId}/messages`, { content });
    return response.data;
  }

  async reportMessage(messageId, reason = 'spam') {
    const response = await apiPrivate.post(`${API_URL}/messages/${messageId}/report`, { reason });
    return response.data;
  }

  async blockUser(blockedUserId, reason = 'manual') {
    const response = await apiPrivate.post(`${API_URL}/blocks`, { blockedUserId, reason });
    return response.data;
  }
}

export default new ChatService();
